/**
 * Simplified data category classifications for CMDB components
 * Based on GDPR and Norwegian regulations
 */
export var DataCategory;
(function (DataCategory) {
    // Personal Data (General GDPR)
    DataCategory["PERSONAL_DATA"] = "personal_data";
    // Special Categories (GDPR Art. 9)
    DataCategory["SPECIAL_CATEGORY_DATA"] = "special_category_data";
    // Financial Data
    DataCategory["FINANCIAL_DATA"] = "financial_data";
    // Authentication & Credentials
    DataCategory["AUTHENTICATION_DATA"] = "authentication_data";
    // Business Sensitive
    DataCategory["BUSINESS_DATA"] = "business_data";
    // System & Operations
    DataCategory["SYSTEM_DATA"] = "system_data";
    // Public Information
    DataCategory["PUBLIC_DATA"] = "public_data";
    // No Sensitive Data
    DataCategory["NO_SENSITIVE_DATA"] = "no_sensitive_data";
})(DataCategory || (DataCategory = {}));
/**
 * Valid data category values for validation
 */
export const VALID_DATA_CATEGORIES = Object.values(DataCategory);
/**
 * Data categories that require special handling under GDPR Art. 9
 */
export const GDPR_SPECIAL_CATEGORIES = [DataCategory.SPECIAL_CATEGORY_DATA];
/**
 * Data categories that require PCI-DSS compliance
 */
export const PCI_DSS_CATEGORIES = [DataCategory.FINANCIAL_DATA];
